export default __webpack_public_path__ + "static/28-a591012661d187e86d7c24d0bdb5500d.jpg";